
import { OnboardingStep } from './useOnboardingState';

interface AppInstallationProps {
  setStep: (step: OnboardingStep) => void;
}

export const useAppInstallation = ({ setStep }: AppInstallationProps) => {
  const handleInstallAppContinue = () => {
    // Mark the app as installed in localStorage
    localStorage.setItem('appInstalled', 'true');
    
    // Log success message
    console.log("Installation réussie! Merci d'avoir installé EasyDJ+");
    
    // Move to email step after installation
    setStep('email');
  };

  const handleInstallAppSkip = () => {
    // Skip the installation step, go to email
    setStep('email');
  };

  return {
    handleInstallAppContinue,
    handleInstallAppSkip
  };
};
